import { FC, useEffect, useState } from "react";
import { useFormik } from "formik";
import { Paper, Loader, Center } from "@mantine/core";
import { editValidationSchema } from "./config";
import { FORM_IDS } from "pages/User/config";
import { userApi } from "apis";
import { useNotification } from "utils/hooks";
import { ErrorStatusType } from "constants/types/common";
import UserFormFields from "../UserFormFields/UserFormFields";
import { UserResponse, UserUpdateBodyType } from "constants/types/user";
import { Loading } from "components";

type Props = {
  user?: UserResponse;
  userId?: string;
  onClose?: () => void;
  mutate?: any;
};

const EditForm: FC<Props> = ({ user, userId, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      username: user!.username || "",
      fullname: user!.fullname || "",
      roles: user?.roles || [],
      phone: user?.phone || "",
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!user?.id) {
        notification.error({ title: "Không tìm thấy ID người dùng" });
        return;
      }

      setIsLoading(true);

      try {
        // Only send phone and roles for update
        const updateData: UserUpdateBodyType = {
          phone: values.phone,
          roles: values.roles,
        };

        const _res = await userApi.updatePhoneRoleUser(user.id, updateData);

        if (_res.data.success) {
          notification.success({ title: "Cập nhật người dùng thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Cập nhật người dùng thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  if (isLoading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <UserFormFields
            formik={formik}
            isCreateMode={false}
            isPasswordReset={false}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
